export class LoggedInUser {
  email: string;
  accessToken: string;
  idToken: string;
  refreshToken: string;
}
